import { jsx as _jsx } from "react/jsx-runtime";
import { ListingDisplayCard } from '@client/components/cards/ListingDisplayCard';
import { ItemGrid } from '@client/components/collections/ItemGrid';
import { CLIENT_ROUTES, LISTING_CARD_SKELETON_ASPECT_RATIO, LISTING_GRID_PAGE_SIZE, STANDARD_GRID_COLUMNS, } from '@client/constants';
import { indexShopTitles } from '@client/utils/shopUtils';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
export const ListingGrid = (props) => {
    const navigate = useNavigate();
    const goToListing = (shortId) => navigate(`/${CLIENT_ROUTES.listing}/${shortId}`);
    const shopTitles = useMemo(() => indexShopTitles(props.shops), [props.shops]);
    return (_jsx(ItemGrid, { items: props.listings, isLoading: props.isLoading, getItemKey: (listing) => listing.id, columns: props.columns ?? STANDARD_GRID_COLUMNS, skeletonAspectRatio: LISTING_CARD_SKELETON_ASPECT_RATIO, pageSize: LISTING_GRID_PAGE_SIZE, renderItem: (listing, isMobile) => (_jsx(ListingDisplayCard, { ...listing, ...(props.shops && {
                shopTitle: shopTitles.get(listing.shopShortId),
            }), ...(isMobile
                ? {
                    onCardBodyClick: () => goToListing(listing.shortId),
                }
                : {
                    onImageClick: () => goToListing(listing.shortId),
                }) })) }));
};
